import React, { Fragment, useState } from 'react';
import { settingsSharp } from 'ionicons/icons';
import { IonButton, IonButtons, IonIcon, IonMenuButton, IonTitle, IonToolbar } from '@ionic/react';
import CountrySelector from './CountrySelector';
import Settings from './Settings';
import './Toolbar.css';

interface ToolbarProps {
  title: string;
};

const Toolbar: React.FC<ToolbarProps> = ({ title }) => {

  const [showSettings, setShowSettings] = useState<boolean>(false);
  const [activeAlarm] = useState<boolean>(false);
  const [hiddenAlert] = useState<boolean>(true);

  return (
    <Fragment>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton />
        </IonButtons>
        <IonTitle className="ion-hide-xl-down" color="primary" size="large"><b>{title}</b></IonTitle>
        <IonButtons className="settingButtons" slot="end">
          <CountrySelector />
          <IonButton onClick={() => setShowSettings(true)} >
            <IonIcon slot="icon-only" icon={settingsSharp}></IonIcon>
          </IonButton>
          <IonButton routerLink={'alarms'} routerDirection="none" hidden={hiddenAlert}>
            <IonIcon slot="icon-only" icon={activeAlarm ? 'assets/corp/icons-notification-active.svg' : 'assets/corp/icons-notification.svg'}></IonIcon>
          </IonButton>
        </IonButtons>
      </IonToolbar>
      <Settings show={showSettings} onClose={() => setShowSettings(false)} />
    </Fragment>
  );
};

export default Toolbar;